////////////////////////////////////////////
// useNetwork — REACTIVE NETWORK STATE FOR COMPONENTS
////////////////////////////////////////////
//
// WRAPS config/network.ts's PURE RESOLVER IN THE ROUTER'S SEARCH PARAMS SO
// COMPONENTS RE-RENDER WHEN ?net / ?launch CHANGE. NON-COMPONENT CODE (API
// MODULES) TAKES THE RESOLVED Network AS AN ARGUMENT INSTEAD.
import { useMemo } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { resolveNetwork, type NetId, type Network } from "@/config/network";

export function useNetwork(): Network {

  const [search] = useSearchParams();
  return useMemo(() => resolveNetwork(search), [search]);
}

// LINK HELPER — APPEND THE NET-CARRYING SUFFIX TO AN INTERNAL PATH
export function withNav(path: string, net: Network): string {

  return path + net.navQuery;
}

////////////////////////////////////////////
// useNetNav — IN-PLACE NET SWITCHING (WALLET MENU)
////////////////////////////////////////////
//
// SPA NAVIGATION ON THE CURRENT PATH. ?launch DROPS ONLY ON A PLATFORM
// SWITCH (A KEY IS CHAIN-BOUND); A SUB-NET FLIP WITHIN THE PLATFORM KEEPS
// EVERY OTHER PARAM. LEGACY ?chain= IS CANONICALIZED AWAY EITHER WAY.
export function useNetNav(): (net: NetId, dropLaunch: boolean) => void {

  const navigate = useNavigate();
  const location = useLocation();
  const [search] = useSearchParams();

  return (net, dropLaunch) => {

    const p = new URLSearchParams(search);
    if (dropLaunch) p.delete("launch");
    p.delete("chain");
    if (net === "mainnet") p.delete("net");
    else p.set("net", net);
    const s = p.toString();
    navigate(location.pathname + (s ? "?" + s : ""));
  };
}
